import { OtpFieldRefType } from '@nw/auth-core';

import { PublicFormMachineStateUnion } from '../../types/MultiStepRegistrationFormTypes';

export const useOtpFieldRef = (
  publicFormMachineState: PublicFormMachineStateUnion
): OtpFieldRefType | null => {
  const authMachineContext = (
    publicFormMachineState.context.authMachineRef as {
      state?: { context?: { otpFieldRef?: OtpFieldRefType | null } };
    } | null
  )?.state?.context;

  return authMachineContext?.otpFieldRef ?? null;
};
